jQuery($ => {

  if($('.o-popup')[0]){
    if (localStorage.getItem('popupState') != 'shown') {
      localStorage.setItem('popupState', 'shown');
      $('.o-popup').show();
    } else {
        $('.o-popup').remove();
    }
    $('.o-popup__modal .m-modal__close').on('click', function() {
      $('.o-popup').remove();
    })
  }

});